// eslint-disable-next-line no-shadow
enum DataExchangeTypes {
    ReadObjectList = 'readObjectList',
    ReadSurveyList = 'readSurveyList',
    ReadObjectData = 'readObjectData',
    ReadSurveyData = 'readSurveyData',
    UpdateObject = 'updateObject',
    AddObject = 'addObject',
    AddSurvey = 'addSurvey',
}

export { DataExchangeTypes };
